const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export function indexIcalBlocksByDay(blocks, dayKeys) {
  const cells = new Map()
  for (const block of blocks) {
    const startsOn = block.start_date
    const endsOn = block.end_date
    if (!DATE_PATTERN.test(startsOn || '') || !DATE_PATTERN.test(endsOn || '') || startsOn >= endsOn) continue
    for (const dayKey of dayKeys) {
      if (dayKey < startsOn || dayKey >= endsOn) continue
      const key = `${block.resource_id}-${dayKey}`
      const existing = cells.get(key) || []
      existing.push(block)
      cells.set(key, existing)
    }
  }
  return cells
}
